module.exports = __webpack_public_path__ + "img/main new.b8304248.jpg";